<template>
  <div class="sub-page">
    <div class="sub-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="$t('foorter.top32') || '通知'" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="sub-body">
      <div class="card form-card">
        <div class="tab-bar">
          <div class="tab-item" :class="{ active: index1 }" @click="toStatus(1)">
            {{ $t('foorter.top33') || '系统公告' }}
          </div>
          <div class="tab-item" :class="{ active: index2 }" @click="toStatus(2)">
            {{ $t('foorter.top34') || '站内消息' }}
          </div>
        </div>

        <div class="content" v-show="index1">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="listItem" v-for="(v, key) in notice" :key="key">
              <div class="listTitle">{{ v.name }}</div>
              <div class="listContent html"><p>{{ v.text }}</p></div>
              <div class="listTimeText">{{ v.create_time }}</div>
            </div>
          </van-pull-refresh>
        </div>

        <div class="content" v-show="index2">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="listItem" v-for="(v, key) in msg" :key="key">
              <div class="listTitle">{{ v.name }}</div>
              <div class="listContent html"><p>{{ v.text }}</p></div>
              <div class="listTimeText">{{ v.create_time }}</div>
            </div>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice: [],
      msg: [],
      index1: true,
      index2: false
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getNoticeList() {
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res => {
        if (res && res.data) {
          this.notice = res.data;
        }
      });
    },
    getMsgList() {
      this.$http({
        method: 'get',
        url: 'sys_get_msg_list'
      }).then(res => {
        if (res && res.data) {
          this.msg = res.data;
        }
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
        this.getMsgList();
      }, 500);
    },
    toStatus(id) {
      if (id === 1) {
        this.index1 = true;
        this.index2 = false;
      } else {
        this.index1 = false;
        this.index2 = true;
      }
    }
  },
  created() {
    this.getNoticeList();
    this.getMsgList();
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .sub-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.sub-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.tab-bar {
  display: flex;
  border-bottom: 2px solid #f0f0f2;
  margin-bottom: 20px;
}

.tab-item {
  flex: 1;
  text-align: center;
  font-size: 28px;
  padding: 16px 0;
  color: #666666;
  font-weight: 500;
  cursor: pointer;

}

.tab-item.active {
  color: #4f2b8a;
  border-bottom: 4px solid #f560cd;
  font-weight: 700;
}

.listItem {
  padding: 20px 0;
  border-bottom: 1px solid #eeeeee;
}

.listTitle {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 10px;
}

.listContent {
  font-size: 26px;
  color: #666666;
  line-height: 1.5;
}

.listTimeText {
  font-size: 22px;
  color: #999999;
  text-align: right;
  margin-top: 10px;
}
</style>
